<template>
    <account-verification-email-sent-provider v-slot="{contact, isWhiteLabeled}">
        <account-verification-email-sent-view
            :contact="contact"
            :isWhiteLabeled="isWhiteLabeled"
        />
    </account-verification-email-sent-provider>
</template>

<script>
    import AccountVerificationEmailSentProvider from "../providers/dashboard/AccountVerificationEmailSentProvider";
    import AccountVerificationEmailSentView from "../data-views/dashboard/AccountVerificationEmailSentView";
    export default {
        name: "AccountVerificationEmailSentRouterView",
        components: {AccountVerificationEmailSentView, AccountVerificationEmailSentProvider}
    }
</script>